<img [src]="'./assets/icons/' + iconName  + '.svg'"
     [alt]="iconName" />